/* global module */
(function () {
  'use strict';
  const strStorageKey='ltss-analytics-session-v1';
  const objUuidPattern=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  function createTelemetry(objOptions) {
    let strSession='',strToken='',intExpiry=0,intBackoff=0,intTimer=0;
    let objSessionPromise=null,objSnapshot=null;
    const objSent=new Set();
    function allowed() { try {return objOptions.consent()===true;} catch(objError){return false;} }
    function clearSession() {
      strSession='';strToken='';intExpiry=0;
      try {objOptions.storage().removeItem(strStorageKey);}catch(objError){}
    }
    function sessionId() {
      if (!strSession) {
        try {strSession=objOptions.storage().getItem(strStorageKey)||'';}catch(objError){}
        if (!objUuidPattern.test(strSession)) strSession=objOptions.uuid();
        try {objOptions.storage().setItem(strStorageKey,strSession);}catch(objError){}
      }
      return strSession;
    }
    async function post(objBody) {
      const objResponse=await objOptions.fetch(objOptions.url,{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify(objBody)});
      if (!objResponse.ok) {
        if (objResponse.status===429) intBackoff=objOptions.now()+60000;
        const objError=new Error('Telemetry request failed');objError.status=objResponse.status;throw objError;
      }
      return objResponse.json();
    }
    async function ensureSession() {
      if (!allowed() || objOptions.now()<intBackoff) return null;
      if (strToken && intExpiry>objOptions.now()+30000) return {token:strToken,session_id:strSession};
      if (!objSessionPromise) {
        const strRequestedSession=sessionId();
        objSessionPromise=post({action:'session',platform_id:objOptions.platform,session_id:strRequestedSession})
          .then(objData=>{
            if (!allowed() || strSession!==strRequestedSession) return null;
            strToken=String(objData.token||'');intExpiry=Number(objData.expires_at)*1000;
            if (!strToken || !Number.isFinite(intExpiry)) return null;
            return {token:strToken,session_id:strSession};
          }).catch(()=>{intBackoff=Math.max(intBackoff,objOptions.now()+10000);return null;})
          .finally(()=>{objSessionPromise=null;});
      }
      return objSessionPromise;
    }
    async function send(objBody,objView,boolRetry=true) {
      if (!allowed() || objOptions.now()<intBackoff) return false;
      const objAuth=await ensureSession();
      if (!objAuth || !allowed() || objSnapshot!==objView) return false;
      try {
        await post({...objBody,...objAuth,platform_id:objOptions.platform});return true;
      } catch(objError) {
        if (objError.status===401 && boolRetry) {strToken='';intExpiry=0;return send(objBody,objView,false);}
        intBackoff=Math.max(intBackoff,objOptions.now()+10000);return false;
      }
    }
    function snapshotWithSession(objView) {return {...objView,session_id:strSession,platform_id:objOptions.platform};}
    async function flush() {
      if (intTimer) {objOptions.cancel(intTimer);intTimer=0;}
      const objView=objSnapshot;
      if (!objView || !allowed() || objSent.has(objView.event_id)) return false;
      const objAuth=await ensureSession();
      if (!objAuth || objSnapshot!==objView || !allowed()) return false;
      const boolOk=await send({action:'result',...snapshotWithSession(objView)},objView);
      if (boolOk) {objSent.add(objView.event_id);if(objSent.size>100)objSent.delete(objSent.values().next().value);}
      return boolOk;
    }
    function invalidate() {if(intTimer)objOptions.cancel(intTimer);intTimer=0;objSnapshot=null;}
    function result(objView) {
      invalidate();
      if (!objView.query && objView.category==='all') return;
      objSnapshot={...objView,products:objView.products.map(objProduct=>({...objProduct})),event_id:objOptions.uuid(),search_id:objOptions.uuid()};
      if (allowed()) {ensureSession();intTimer=objOptions.schedule(flush,1000);}
    }
    async function click(strProduct,intPosition) {
      const objView=objSnapshot;
      if (!objView || !allowed() || objView.products[intPosition-1]?.id!==strProduct) return false;
      if(intTimer)objOptions.cancel(intTimer);intTimer=0;
      const objAuth=await ensureSession();
      if (!objAuth || objSnapshot!==objView || !allowed()) return false;
      const boolOk=await send({action:'click',event_id:objOptions.uuid(),search_id:objView.search_id,product_id:strProduct,position:intPosition,snapshot:snapshotWithSession(objView)},objView);
      if(boolOk)objSent.add(objView.event_id);
      return boolOk;
    }
    function consentChanged() {
      if(!allowed()){invalidate();clearSession();return;}
      ensureSession();if(objSnapshot)intTimer=objOptions.schedule(flush,1000);
    }
    return {result,click,flush,invalidate,consentChanged,prepare:ensureSession};
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={createTelemetry};
  if(typeof window!=='undefined')window.LucidSmartSearchTelemetryFactory=createTelemetry;
  if(typeof document==='undefined')return;
  function uuid() {
    if(crypto.randomUUID)return crypto.randomUUID();
    const arrBytes=crypto.getRandomValues(new Uint8Array(16));arrBytes[6]=(arrBytes[6]&15)|64;arrBytes[8]=(arrBytes[8]&63)|128;
    const strHex=Array.from(arrBytes,objValue=>objValue.toString(16).padStart(2,'0')).join('');
    return [strHex.slice(0,8),strHex.slice(8,12),strHex.slice(12,16),strHex.slice(16,20),strHex.slice(20)].join('-');
  }
  function boot() {
    const objShell=document.querySelector('[data-ltss]');if(!objShell)return;
    const objConfig=JSON.parse(objShell.querySelector('[data-config]').textContent);
    if(!objConfig.telemetry)return;
    const objSdk=createTelemetry({platform:objConfig.telemetry.platform,url:objConfig.telemetry.url,
      consent:()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true,
      now:()=>Date.now(),uuid,storage:()=>window.sessionStorage,fetch:window.fetch.bind(window),schedule:window.setTimeout.bind(window),cancel:window.clearTimeout.bind(window)});
    window.LucidSmartSearchTelemetry=objSdk;
    document.addEventListener('visitorConsentCollected',objSdk.consentChanged);
    function onClick(objEvent) {
      if(objEvent.type==='auxclick'&&objEvent.button!==1)return;
      const objLink=objEvent.target.closest('.ltss-product-link[data-product-id]');
      if(!objLink||!objShell.contains(objLink))return;
      const arrLinks=Array.from(objShell.querySelectorAll('[data-results] .ltss-product-link[data-product-id]'));
      objSdk.click(objLink.dataset.productId,arrLinks.indexOf(objLink)+1);
    }
    objShell.addEventListener('click',onClick);objShell.addEventListener('auxclick',onClick);
    if(window.Shopify?.customerPrivacy)objSdk.prepare();
    else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],objError=>{if(!objError)objSdk.consentChanged();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
